var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"carousel-container"},[_c('el-carousel',{staticClass:"ig-carousel",attrs:{"height":_vm.height+'px',"autoplay":_vm.autopaly,"interval":_vm.interval}},_vm._l((_vm.list),function(item){return _c('el-carousel-item',{key:item.id},[_c('div',{staticClass:"carousel-img",style:({'backgroundImage':'url('+item+')'})})])}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }